import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { SelfDigitalIntensityScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-digital-intensity-score.aggregate-root';
import { GetSelfDigitalIntensityScoreResponseDto } from '../../../interface/dtos/scores/self-get-digital-intensity-score.response.dto';

export type ISelfDigitalIntensityScoreAggregateRootMapper = Mapper<
  SelfDigitalIntensityScoreAggregateRoot,
  GetSelfDigitalIntensityScoreResponseDto
>;

export class SelfDigitalIntensityScoreAggregateRootMapper
  implements Omit<ISelfDigitalIntensityScoreAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: SelfDigitalIntensityScoreAggregateRoot
  ): GetSelfDigitalIntensityScoreResponseDto {
    return SelfDigitalIntensityScoreAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfDigitalIntensityScoreAggregateRoot
  ): GetSelfDigitalIntensityScoreResponseDto {
    return {
      value: `${entity.thisPeriodDigitalIntensityScore}`,
      unformattedValue: entity.thisPeriodDigitalIntensityScore,
      allTimeAverage: entity.allTimeAverageDigitalIntensityScore.toString(),
      max: entity.allTimeMaxDigitalIntensityScore.toString(),
      deviationFromAveragePercentage: formatDeviation(
        entity.deviationFromAvereagePercentage
      ),
      name: entity.name,
    };
  }
}
